<template>
    <div v-if="Alerts && Alerts.length">
        <div 
            v-for="alert in Alerts" 
            :key="alert.id" 
            :id="alert.AlertTitle" 
            class="header-alert" 
            :class="alert.AlertType ? alert.AlertType.AlertCssClass : ''"
            role="alert" 
            :aria-label="`${alert.AlertType ? alert.AlertType.AlertCssClass : ''} ${alert.AlertTitle}`"
            aria-atomic="true"
        >
            <h5 class="fulton-alert">
                {{ alert.AlertTitle }}
            </h5>
            <div class="details">
                <p>
                    {{ alert.AlertDescription }}
                </p>
            </div>
            <div class="shut">
                <button class="close-alert" aria-label="close alert">
                    ×
                </button>
            </div>
        </div>
    </div>
</template>

<script>
	
	export default {
		name: 'Alerts',
		props: ['Alerts']
	}
	
</script>